import {Injectable} from '@angular/core';
import {ConfigService} from './config.service';
import {HttpClient} from '@angular/common/http';
import {Nominee} from '../model/nominee.model';


@Injectable()
export class NomineeService {
    private readonly httpClient: HttpClient;
    private readonly configService: ConfigService;

    constructor(httpClient: HttpClient, configService: ConfigService) {
        this.httpClient = httpClient;
        this.configService = configService;
    }

    public async create(nominee: Nominee): Promise<Nominee> {
        const url = `${this.configService.getInvestmentServiceBaseUrl()}/nominee`;
        return await this.httpClient.post<Nominee>(url, nominee).toPromise();
    }

    public async findNomineeByUserId(userId: string): Promise<Nominee> {
        const url = `${this.configService.getInvestmentServiceBaseUrl()}/nominee?userId=${userId}`;
        return await this.httpClient.get<Nominee>(url).toPromise();
    }

    public async update(nomineeId: string, nominee: Nominee): Promise<Nominee> {
        const url = `${this.configService.getInvestmentServiceBaseUrl()}/nominee/${nomineeId}`;
        return await this.httpClient.put<Nominee>(url, nominee).toPromise();
    }
}
